import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalHook() {
  const quotes = ['Solo una para calmarme.', 'Solo hoy.', 'Me lo merezco.', 'Después lo dejo.'];
  return <section className="py-24 md:py-32 px-6 bg-white/50" data-id="element-58">
      <div className="max-w-2xl mx-auto" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-serif text-[#2D2A26] mb-10" data-id="element-61">
            ¿Te pasó esto?
          </h2>

          <div className="space-y-6 text-[#3D3D3D] text-lg md:text-xl leading-relaxed" data-id="element-62">
            <p data-id="element-63">
              Dices{' '}
              <span className="font-semibold text-[#B8845A]" data-id="element-64">"ya no más"</span>…
            </p>

            <p data-id="element-65">Pero a los pocos días llega la ansiedad.</p>

            <p data-id="element-66">Y no es una ansiedad suave.</p>

            <p className="font-medium text-[#2D2A26] border-l-4 border-[#C4956A] pl-6 py-3 bg-[#FAF8F5] rounded-r-lg text-lg md:text-xl" data-id="element-67">
              Es esa que se siente en el pecho, en el estómago, en la piel.
            </p>

            <p className="text-[#4D4A46]" data-id="element-68">
              Esa que te quita el sueño.
              <br data-id="element-69" />
              Esa que te hace pensar demasiado.
              <br data-id="element-70" />
              Esa que te deja irritable, vacío/a, acelerado/a o con ganas de
              escapar.
            </p>

            <p className="pt-4" data-id="element-71">Entonces tu mente hace lo que ya conoce:</p>

            <div className="grid grid-cols-2 gap-4 my-10" data-id="element-72">
              {quotes.map((quote, index) => <div key={index} className="bg-white p-5 rounded-xl shadow-sm border border-[#E5E0D8] text-center italic text-[#6B7A5E] text-base" data-id="element-73">
                  "{quote}"
                </div>)}
            </div>

            <p className="text-lg md:text-xl" data-id="element-74">
              Y cuando te das cuenta…{' '}
              <span className="font-semibold text-[#C4804C]" data-id="element-75">
                volviste a caer.
              </span>
            </p>
          </div>

          <div className="mt-14 p-8 md:p-10 bg-[#FAF8F5] rounded-2xl border border-[#E5E0D8]" data-id="element-76">
            <p className="text-xl md:text-2xl font-serif text-[#2D2A26] mb-5 leading-snug" data-id="element-77">
              Si esto te suena familiar, quiero decirte algo sin rodeos:
            </p>
            <p className="text-lg md:text-xl text-[#3D3D3D] leading-relaxed" data-id="element-78">
              La mayoría de las recaídas no pasan por falta de voluntad. Pasan
              porque{' '}
              <span className="font-semibold underline decoration-[#C4956A] decoration-2 underline-offset-4" data-id="element-79">
                nadie te enseñó qué hacer cuando el cuerpo entra en modo alarma.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}